import { Box, CircularProgress, Container, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { termsService } from 'src/db/terms.service';
import { ROUTES } from 'src/routes';
import { Terms } from 'src/term.interface';

export const TermsPage = () => {
  const [terms, setTerms] = useState<Terms | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const terms = await termsService.fetchTerms();
      setTerms(terms);
      setLoading(false);
    })();
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <NavLink to={ROUTES.HOME}>Home</NavLink>
      <Typography variant="h4" gutterBottom>
        Workbench Studio Terms of Service
      </Typography>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        terms && <TermsContent terms={terms} />
      )}
    </Container>
  );
};

export const TermsContent = ({ terms }: { terms: Terms }) => {
  return (
    <Box>
      {terms && (
        <>
          <Box
            dangerouslySetInnerHTML={{ __html: terms.content }}
            sx={{
              '& a': { color: 'primary.main' },
              '& h1, & h2, & h3, & h4, & h5, & h6': { mt: 3, mb: 2 },
              '& p': { mb: 2 },
              '& ul, & ol': { mb: 2, pl: 3 },
            }}
          />
          <Typography variant="body2">
            Effective as of {terms.timestamp.toDate().toLocaleDateString()}
          </Typography>
        </>
      )}
    </Box>
  );
};
